/* eslint-disable @typescript-eslint/no-explicit-any */

import {
  Component,
  ElementRef,
  HostListener,
  Inject,
  OnInit,
  ViewChild,
  DOCUMENT
} from '@angular/core';

import { SearchService } from '../navbar-search/services/search.service';

@Component({
  selector: 'xbaht-navbar-bookmark',
  templateUrl: './navbar-bookmark.component.html',
  styleUrl: './navbar-bookmark.component.scss',
  standalone: false
})
export class NavbarBookmarkComponent implements OnInit {
  public bookmarkText = '';
  public openBookmarkRef = false;
  public activeIndex = 0;
  public apiData: any;
  public pages: any;
  public bookmarkSearchLimit: any;
  public bookmarkedItems: any;

  @ViewChild('openBookmark') private _bookmarkElement!: ElementRef;

  @HostListener('keydown.escape') public fn() {
    this.removeOverlay();
    this.openBookmarkRef = false;
    this.bookmarkText = '';
  }

  @HostListener('document:click', ['$event'])
  public clickout(event: MouseEvent) {
    const target = event.target as HTMLElement | null;

    if (target?.className === 'content-overlay') {
      this.removeOverlay();
      this.openBookmarkRef = false;
      this.bookmarkText = '';
    }

    if (!(target?.nodeName === 'INPUT') && this.openBookmarkRef === true) {
      this.removeOverlay();
      this.openBookmarkRef = false;
      this.bookmarkText = '';
    }
  }

  constructor(
    @Inject(DOCUMENT) private document: any,
    public _searchService: SearchService
  ) {}

  ngOnInit(): void {
    this._searchService.onApiDataChange.subscribe((res: any) => {
      this.apiData = res;
      this.pages = this.apiData[0].data;
      this.bookmarkedItems = this.pages.filter(
        (page: any) => page.isBookmarked === true
      );
      this.bookmarkSearchLimit = this.apiData[0].bookmarkLimit;
    });
    this._searchService.onIsBookmarkOpenChange.subscribe((res: boolean) => {
      this.openBookmarkRef = res;
    });
  }

  public addBookmark(id: any) {
    const index = this.pages.findIndex((object: any) => {
      return object.id === id;
    });
    this.pages[index].isBookmarked = true;

    this.bookmarkedItems.push(this.pages[index]);
  }

  public removeBookmark(id: any) {
    const index = this.bookmarkedItems.findIndex((object: { id: any }) => {
      return object.id === id;
    });
    this.bookmarkedItems[index].isBookmarked = false;
    this.bookmarkedItems.splice(index, 1);
  }

  public openBookmark() {
    this.openBookmarkRef = true;
    this._searchService.onIsBookmarkOpenChange.next(this.openBookmarkRef);
  }

  public closeBookmark() {
    this.openBookmarkRef = false;
    this._searchService.onIsBookmarkOpenChange.next(this.openBookmarkRef);
  }

  public removeOverlay() {
    this.document
      .querySelector('.app-content')
      .classList.remove('show-overlay');
  }

  public nextActiveMatch() {
    this.activeIndex =
      this.activeIndex < this.bookmarkSearchLimit - 1
        ? ++this.activeIndex
        : this.activeIndex;
  }

  public prevActiveMatch() {
    this.activeIndex = this.activeIndex > 0 ? --this.activeIndex : 0;
  }

  public autoSuggestion(event: any) {
    if (38 === event.keyCode) {
      return this.prevActiveMatch();
    }
    if (40 === event.keyCode) {
      return this.nextActiveMatch();
    }
  }

  public toggleBookmark(id: any) {
    const index = this.pages.findIndex((object: any) => {
      return object.id === id;
    });
    if (this.pages[index].isBookmarked === true) {
      this.removeBookmark(id);
    } else {
      this.addBookmark(id);
    }
  }

  public toggleBookmarkPopup() {
    setTimeout(() => {
      if (this.openBookmarkRef === false) {
        this.openBookmark();
      } else {
        this.closeBookmark();
      }
      setTimeout(() => {
        this._bookmarkElement.nativeElement.focus();
      }, 0);
    }, 0);
  }

  public bookmarkUpdate(event: any) {
    const val = event.target.value.toLowerCase();
    if (val !== '') {
      this.document.querySelector('.app-content').classList.add('show-overlay');
    } else {
      this.document
        .querySelector('.app-content')
        .classList.remove('show-overlay');
    }
    this.autoSuggestion(event);
  }
}
